export default class HealthPlanConfig {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/healthplanconfig";
  }
  listHealthPlanConfigs() {
    return this.client.get(`${this.resourceUrl}/allclients?`);
  }

  fetchHealthPlanConfigDetail(healthPlanClientKey) {
    return this.client.get(
      `${this.resourceUrl}/configdetails/${healthPlanClientKey}`
    );
  }

  fetchUserListBySkill(userSkill) {
    return this.client.get(`${this.resourceUrl}/userbyskill/${userSkill}`);
  }

  fetchAllUsers() {
    return this.client.get(`${this.resourceUrl}/userbyskill/all`);
  }

  updateHealthPlanConfig(healthPlanClientKey, updatedData) {
    return this.client.post(
      `${this.resourceUrl}/updateconfig/${healthPlanClientKey}`,
      updatedData
    );
  }

  getDraftAdoptionDecisions(hpKey, policyKey) {
    return this.client.get(
      `/healthplan/policyEnforcementRules/draftAdoptionDecisions/${hpKey}/${policyKey}`
    );
  }

  saveAdoptionDecisionsAsDraft(draftData) {
    return this.client.post(
      `/healthplan/policyEnforcementRules/saveAdoptionDecisionsAsDraft`,
      draftData
    );
  }

  getAvalonBasePolicies(payload) {
    return this.client.post(`/policyConfig/avalonBasePolicies`, payload);
  }

  getHPPolicies(payload) {
    return this.client.post(`/policyConfig/HPPolicies`, payload);
  }

  createHealthPlanPolicies() {
    return this.client.post(`/policyConfig/createHealthPlanPolicies`);
  }
}
